import { h } from 'preact';
import React, { Component } from 'react';

import { Sanitize } from '../../Sanitize/Sanitize';
import Toggle from '../Components/Toggle';

import { formatDescription, makeText, isActionAllowed } from '../../../util';

export default class PurposeContent extends Component {
  state = {
    consentAll: false,
    liAll: false,
    discolsureAll: false,
  }
  toggleConsentAll = () => {
    const consentAll = !this.state.consentAll;
    this.setState({ consentAll }, this.props.force);
  }
  toggleLiAll = () => {
    const liAll = !this.state.liAll;
    this.setState({ liAll }, this.props.force);
  }
  toggleDisclosure = () => {
    const discolsureAll = !this.state.discolsureAll;
    this.setState({ discolsureAll }, this.props.force);
  }
  render() {
    const {
      selected,
      purpose,
      settings,
      language,
      force,
      dev,
      disclosure,
      isCustom,
      accordionOpen
    } = this.props;

    const { consentAll, liAll, discolsureAll } = this.state;

    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);
    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language)
    const vendorTitleText = makeText(Boolean(dev), settings, 'vendorTitleText', language)

    const description = isCustom
      ? (
        <p style="margin-bottom:15px;" dangerouslySetInnerHTML={{ __html: Sanitize({ html: purpose.description }) }} />
      )
      : (
        <p style="margin-bottom:15px;">
          {formatDescription(purpose.description)}
        </p>
      );

    if (settings.alphabetizeVendors) {
      if (purpose.requiringConsentVendors) {
        purpose.requiringConsentVendors.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
      if (purpose.legIntVendors) {
        purpose.legIntVendors.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
      if (purpose.disclosureOnlyVendors) {
        purpose.disclosureOnlyVendors.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
    }
    
    return (
      <div className="purpose-content">
        {description}
        <div className="policies">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {purpose[selected === 'consent'
              ? purpose.disclosureOnly ? 'disclosureOnlyVendors' : 'requiringConsentVendors'
              : 'legIntVendors'].length} {vendorTitleText}
            <div className="legend">
              <span className="legend-key" aria-hidden>
                {otherLetter}
              </span>
              <h2 class="custom-header">
                {otherText}
              </h2>
            </div>
          </div>
        </div>
        {selected === 'consent' && (
          <div>
            <div className="policies">
              {purpose.requiringConsentVendors.slice(0, consentAll ? purpose.requiringConsentVendors.length : 3)
                .map((v) => (
                  <Toggle
                    vendor={v}
                    key={v.vendorId}
                    language={language}
                    settings={settings}
                    force={force}
                    accordionOpen={accordionOpen}
                  />
                ))}
              {purpose.requiringConsentVendors.length > 3 && (
                <div
                  tabIndex={accordionOpen ? 0 : -1}
                  className="view-all"
                  role="button"
                  onClick={this.toggleConsentAll}
                  onKeyDown={e => isActionAllowed(e.key) && this.toggleConsentAll()}
                >
                  {consentAll ? viewLessText : viewAllText}
                </div>
              )}
            </div>
          </div>
        )}
        {selected === 'li' && (
          <div style={{ position: 'relative' }}>
            <div className="policies">
              {purpose.legIntVendors.slice(0, liAll ? purpose.legIntVendors.length : 3).map((v) => (
                <Toggle
                  vendor={v}
                  key={v.vendorId}
                  language={language}
                  settings={settings}
                  force={force}
                  accordionOpen={accordionOpen}
                />
              )
              )}
              {purpose.legIntVendors.length > 3 ? (
                <div
                  tabIndex={accordionOpen ? 0 : -1}
                  className="view-all"
                  role="button"
                  onClick={this.toggleLiAll}
                  onKeyDown={e => isActionAllowed(e.key) && this.toggleLiAll()}
                >
                  {liAll ? viewLessText : viewAllText}
                </div>
              ) : null}
            </div>
          </div>
        )}
        {disclosure === true && (
          <div style={{ position: 'relative' }}>
            <div className="policies">
              {purpose.disclosureOnlyVendors.slice(0, discolsureAll ? purpose.disclosureOnlyVendors.length : 3).map((v) => (
                <Toggle
                  vendor={v}
                  key={v.vendorId}
                  language={language}
                  settings={settings}
                  force={force}
                  accordionOpen={accordionOpen}
                />
              ))}
              {purpose.disclosureOnlyVendors.length > 3 ? (
                <div
                  tabIndex={accordionOpen ? 0 : -1}
                  className="view-all"
                  role="button"
                  onClick={this.toggleDisclosure}
                  onKeyDown={e => isActionAllowed(e.key) && this.toggleDisclosure()}
                >
                  {discolsureAll ? viewLessText : viewAllText}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}